import { Pipe, PipeTransform } from '@angular/core';
import { ErrorMessages } from '@app/_models';

@Pipe({
  name: 'errorfilter',
  pure: false,
})
export class ErrorFilterPipe implements PipeTransform {
  transform(errorMesages: any[], filter: Object): any {
    if (!errorMesages || !filter) {
      return errorMesages;
    }
    const index = errorMesages.findIndex(
      (file) => file.error.toString() === filter.toString()
    );
    if (errorMesages[index] == undefined) {
      errorMesages[index] = errorMesages[0];
    }
    return [errorMesages[index]];
  }
}
